import React from 'react'
import PropTypes from 'prop-types'

function TextLink({ data }) {
  // links data
  const { isExternalLink, url, title, openInNewWindow } = data
  const linkUrl = isExternalLink ? url : `${process.env.GATSBY_BASE_URL}${url}`
  return (
    <a
      className="modal-link"
      href={linkUrl}
      target={openInNewWindow ? '_blank' : '_self'}
      rel={openInNewWindow ? 'noreferrer' : ''}
    >
      {title}
    </a>
  )
}

TextLink.propTypes = {
  data: PropTypes.object.isRequired
}

export { query as data } from './textLinkQuery'

export default TextLink
